import React, { useState, useEffect, useRef } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { SiAppstore } from "react-icons/si";

function ProjectCards(props) {
  // State to track the current image index
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  // Ref to store the interval ID for cleanup
  const intervalRef = useRef(null);

  // Start image rotation when mouse enters the card
  const startImageRotation = () => {
    if (Array.isArray(props.imgPath) && props.imgPath.length > 1 && !intervalRef.current) {
      intervalRef.current = setInterval(() => {
        setCurrentImageIndex(prevIndex => (prevIndex + 1) % props.imgPath.length);
      }, 1000);
    }
  };

  // Stop image rotation and reset to first image when mouse leaves the card
  const stopImageRotation = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setCurrentImageIndex(0);
  };

  // Get the current image to display
  const currentImage = Array.isArray(props.imgPath) 
    ? props.imgPath[currentImageIndex] 
    : props.imgPath;

  // Clean up interval on component unmount
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return (
    <Card 
      className="project-card-view"
      onMouseEnter={startImageRotation}
      onMouseLeave={stopImageRotation}
    >
      {currentImage ? (
        <Card.Img
          variant="top"
          src={currentImage}
          alt="card-img"
          style={{
            transition: "opacity 0.3s ease-in-out",
            opacity: intervalRef.current ? 1 : 0.95
          }}
        />
      ) : (
        <div
          style={{
            height: "160px",
            background: "linear-gradient(135deg, #623aa2 0%, #c084fc 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "3em",
            color: "white",
            borderRadius: "0.25rem 0.25rem 0 0",
          }}
        >
          {props.isAppStore ? "📱" : "🚀"}
        </div>
      )}
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

        {props.techTags && props.techTags.length > 0 && (
          <div style={{ marginBottom: "15px" }}>
            {props.techTags.map((tag, index) => (
              <span
                key={index}
                style={{
                  display: "inline-block",
                  background: "rgba(192, 132, 252, 0.15)",
                  color: "#c084fc",
                  border: "1px solid rgba(192, 132, 252, 0.3)",
                  borderRadius: "12px",
                  padding: "2px 10px",
                  fontSize: "0.75em",
                  marginRight: "6px",
                  marginBottom: "6px",
                }}
              >
                {tag}
              </span>
            ))}
          </div>
        )}

        {props.isAppStore && props.appStoreLink && (
          <Button
            variant="primary"
            href={props.appStoreLink}
            target="_blank"
            style={{
              background: "linear-gradient(135deg, #623aa2, #c084fc)",
              border: "none",
            }}
          >
            <SiAppstore /> &nbsp;
            App Store
          </Button>
        )}

        {!props.onlyDemo && (
          <Button variant="primary" href={props.ghLink} target="_blank" style={props.isAppStore ? { marginLeft: "10px" } : {}}>
            <BsGithub /> &nbsp;
            {props.isBlog ? "Blog" : "GitHub"}
          </Button>
        )}
        {props.websiteLink && (
          <Button
            variant="primary"
            href={props.websiteLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {"Website"}
          </Button>
        )}

        {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

export default ProjectCards;